import type { FeaturePhase, FeatureVersion } from '@/src/types/featureExperience'

export const TRADING_HOURS_CUTOVER_SESSION_STORAGE_KEY = 'gyg.fe.trading_hours.cutover_session_notice_v1'

export const TRADING_HOURS_PILOT_SHORT =
  'You are in the trading hours pilot group. Your feedback helps us refine the v3 layout before wider rollout.'

export function tradingHoursCutoverBannerLines(formattedCutover: string): readonly [string, string] {
  return [
    `You can switch between classic and new trading hours layout until ${formattedCutover}.`,
    'After that time, only the new trading hours experience will be available — classic will be retired.'
  ]
}

export function tradingHoursToggleLabel(version: FeatureVersion): string {
  return version === 'next' ? 'Layout: New' : 'Layout: Classic'
}

export function tradingHoursResolvedDescription(version: FeatureVersion, phase: FeaturePhase): string {
  if (phase === 'available') {
    return version === 'next'
      ? 'New trading hours (v3). Toggle off for the classic layout anytime.'
      : 'Classic trading hours. Toggle on to try the v3 layout anytime.'
  }

  return version === 'next'
    ? 'Redesigned trading hours: updated calendar, temporary and permanent hours.'
    : 'Original trading hours layout and workflows.'
}
